import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a641eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DeductItem" }
const _hoisted_2 = { class: "other-btn" }
const _hoisted_3 = { class: "collapse-box" }
const _hoisted_4 = { style: {"margin":"0 20px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  slot: "default",
  class: "el-icon-plus"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 支持 jpeg, jpg, png 格式，不超过20m ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "视频支持 mp4, avi, mov 等格式，不超过20m", -1))
const _hoisted_8 = {
  key: 1,
  controls: "",
  lazy: "",
  preload: "metadata",
  class: "video-player"
}
const _hoisted_9 = ["src"]

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { createPageData, editPageData,getListData } from '@/service/main/system'
import { getPolicy } from '@/service/common/common'
import { reverseTimestamp } from '@/utils/date-format'
import { ref,onMounted,reactive,nextTick} from 'vue'
import { useStore } from '@/store'
import type { ElFile, UploadFile } from 'element-plus/lib/el-upload/src/upload.type'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import RichTextEditor from '@/components/RichTextEditor.vue'
import { initEmptyParam } from '@/hooks/useInitParam'
import { ElForm,ElMessage, ElMessageBox,ElLoading, } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialManage',
  setup(__props) {

initEmptyParam()
const modalTitle = ref('新增')
const store = useStore()
const isDisabled=ref(false);
// 添加控制折叠面板展开项的响应式变量
const activeCollapseItems = ref<string[]>([])
//详情 原始数据
const rawData = ref<any>({})

const formList =ref<any>([])
// 存储所有表单实例的 ref 数组
const formRefs = ref<any>([])

// 动态设置表单 ref
const setFormRef = (el:any, index:number) => {
  if (el) {
    formRefs.value[index] = el;
  }
};

// 定义校验规则
const dynamicRules = reactive({
  contentType: [
   { required: true, message: '类型必选', trigger: 'blur' }
  ],
  sort: [
   { required: true, message: '请输入排序值 0-100 之间', trigger: 'blur' }
  ],
});
const newCb = () => {
  modalTitle.value = '新增'
  btnDisabled.value=false
  activeCollapseItems.value=[]
  pageModalRef.value.isBatch=true;
  const newItem = {
    id: Date.now() + Math.random(), // 添加唯一标识符
    contentType: '1',
    sort: 1,
    content:'',
    isDisabled:false
  }
  formList.value=[newItem] 
   isDisabled.value=false
   modalConfig.formItems.forEach(item => { 
      item.isDisabled=false
  })
   // 将新添加的项设为展开状态
  activeCollapseItems.value.push(`contents-${newItem.id}`)

}
const editCb = async(item:any) => {
  modalTitle.value = '编辑'
  btnDisabled.value=false
  activeCollapseItems.value=[]
  pageModalRef.value.isBatch=true;
  pageModalRef.value.dialogVisible = false;
  let data = await getListData(`/main/speech/getSpeechTitleDetail/${item.titleId}`,{})
   rawData.value =JSON.parse(JSON.stringify(data))
   defaultInfo.value={
        titleId:data.speechTitle.titleId,
        title:data.speechTitle.title,
        sort:data.speechTitle.sort,
    }
   if(data.speechDetailList && data.speechDetailList.length>0){
      formList.value = data.speechDetailList.map((val:any) => {
          return {
            contentType: val.contentType,
            content: val.content,
            detailId:val.detailId,
            sort:val.sort,
            isDisabled:true
          }
        })
      formList.value.forEach((element:any,index:number) => {
        if(element.contentType=='2' || element.contentType=='3'){
          element.urlLists = [{name:`media-${element.contentType}-${index}`,url:element.content}]
        }
        activeCollapseItems.value.push(`contents-${element.detailId}`)
      });
  }else{
    formList.value =[]
     addContent(formList.value)
  } 
  pageModalRef.value.dialogVisible = true;
  isDisabled.value=true
  // 将新添加的项设为展开状态
  modalConfig.formItems.forEach(e => {
    if(e.field == 'type' || e.field == 'title' ){
      e.isDisabled = true
    } 
  })
}
const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

const btnDisabled=ref(false)
//基础表单提交事件
const handleConfirmClick =()=>{ 
  pageModalRef.value.lfFormRef?.validate(async (isValid:any) => {
     if (isValid ){
       let formData = {...pageModalRef.value.formData}
       const pageUrl = defaultInfo.value?.titleId ? `/main/speech/updateSpeechTitle` : `/main/speech/addSpeechTitle`
       const put = defaultInfo.value?.titleId ? editPageData : createPageData
       const obj= defaultInfo.value?.titleId ?
            {
               sort:formData.sort,
               title: formData.title,
               titleId: Number(defaultInfo.value.titleId),
            }:{ 
                sort:formData.sort,
                title: formData.title,
              }
      let res = await put(pageUrl, obj)
       if(res){
        ElMessage({ type: 'success',message: '提交成功！'})
        if(res.titleId){
          defaultInfo.value={
              titleId:res.titleId,
              title:formData.title,
              sort:formData.sort,
          }
        }
        pageModalRef.value.lfFormRef.allDisabled = true
        btnDisabled.value=true
        let loadingInstance: ILoadingInstance = {} as ILoadingInstance
        if (document.querySelector('.el-table__body-wrapper')) {
          loadingInstance = ElLoading.service({
            target: '.el-table__body-wrapper',
            text: '加载中....',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.8)',
            fullscreen: false
          })
        }
        store.dispatch('system/getPageListAction', {
            pageName: 'speech',
            queryInfo: store.state.system.queryInfo
          })
          .finally(() => {
            if (
              loadingInstance &&
              typeof loadingInstance.close == 'function'
            ) {
              loadingInstance.close()
            }
          })
       }else{
        ElMessage({ type: 'error',message: '操作失败！'})
      }                  
     }
  })
}
//基础表单重置
const handleCancleClick =()=>{ 
  if(modalTitle.value == '新增'){
       defaultInfo.value={}
  }else{ 
   defaultInfo.value={
        titleId:rawData.value.titleId,
        title:rawData.value.title,
        sort:rawData.value.sort,
    }
  }
}
const action=ref('')
const extraData=ref({})
const policyData =ref()
const filesMap = ref<Map<String, String>>(new Map)
const beforeUpload = async (file: UploadFile,item:any) => {
  policyData.value = await getPolicy()
    const key =
      policyData.value.dir +
      reverseTimestamp() +
      file.name.substring(file.name.lastIndexOf('.')) 
      extraData.value = {
        ...policyData.value,
        OSSAccessKeyId: policyData.value.accessId,
        key
      }
     action.value = policyData.value.host
    //  item.urlList.push(policyData.value.host + '/' + key)
     item.content=policyData.value.host + '/' + key
     filesMap.value.set(String(file.uid), policyData.value.host + '/' + key)
}
//素材图片删除
const handleImgRemove = (uploadFile: any, uploadFiles: any,item: any) => {
  item.content=''
  // const list=JSON.parse(JSON.stringify(uploadFiles))
  //  const index = list.findIndex((file: any) => file.uid === uploadFile.uid);
  //  item.urlList.splice(index, 1);
}

// 使用内置URL对象进行验证（推荐）
const isValidURLBuiltIn = (string: string) => {
  try {
    new URL(string)
    return true
  } catch (_) {
      return false
  }
}
//链接正则验证规则
const getContentRules = (contentType: string) => {
  if (contentType === '4') {
    return [
      { required: true, message: '请输入链接', trigger: 'blur' },
      { 
        validator: (rule: any, value: string, callback: any) => {
          if (value && !isValidURLBuiltIn(value)) {
            callback(new Error('请输入有效的链接地址'))
          } else {
            callback()
          }
        }, 
        trigger: 'blur' 
      }
    ]
  }
  return { required: true, message: '素材必传', trigger: 'blur' }
}
let dialogUrl = ref()
let dialogType = ref()
const dialogVisible = ref(false)
//图片视频预览
const handlePreview = (file: any,item:any) => {
  dialogUrl.value = item.content
  dialogType.value=item.contentType
  dialogVisible.value = true
}

onMounted (()=>{
})
const typeList= ref([
  { label: '文本', value: '1' },
  { label: '图片', value: '2' },
  { label: '视频', value: '3' },
  { label: '链接', value: '4' },
])
//新增素材项
const addContent=(contents:any)=>{
  if(!contents){
     contents=[]
  } 
  const newItem = {
     id: Date.now() + Math.random(), // 添加唯一标识符
      contentType: '1',
      sort: contents.length>0 ? contents[contents.length-1].sort+1 :1,
      content:'',
      isDisabled:false
  }
  contents.push(newItem)
    // 将新添加的项设为展开状态
    activeCollapseItems.value = [...activeCollapseItems.value,`contents-${newItem.id}`]
}
//删除素材项
const handleItemRemove=(index:any,list:any,item:any)=>{
   if(list.length > 1){
    ElMessageBox.confirm('确定要删除吗？','注意',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=> {
      if(item.detailId){
        store.dispatch('system/deletePageDataAction', {
          pageName: 'speech',
          id:  item.detailId,
          delUrl:'/main/speech/deleteSpeechDetail'
        }).then((res)=>{
        }).catch(()=>{
            ElMessage({
              message: '删除失败',
              type: 'error'
            })
        })
      }else{
        ElMessage({
        message: '删除成功',
        type: 'success'
      })
      }
      list.splice(index, 1);
      // 注意：移除元素后，formRefs 数组也需要同步清理
      formRefs.value.splice(index, 1);
    }).catch(()=>{
      ElMessage({
        message: '取消删除',
        type: 'warning'
      })
    })
   }else{
    ElMessage({ type: 'warning',message: '必须保留一条或一条以上数据！'})
   }
}
// 处理单个表单提交
const handleSubmit = async (index:number,list:any,item:any) => {
  if(item.isDisabled) {
     item.isDisabled=false;
     return;
  }
    // 可以在这里调用 API 将数据发送到后端
    if(defaultInfo.value?.titleId){
      // 通过索引获取对应的表单实例并进行校验
       try {
          await formRefs.value[index].validate();
          // 校验通过，在这里执行你的提交逻辑
           let url = item.detailId ? '/main/speech/updateSpeechDetail':'/main/speech/addSpeechDetail'
           let put = item.detailId ? editPageData : createPageData
           let res = await put(url,{ 
              contentType: item.contentType,
              content:item.content,
              sort: item.sort ? item.sort: index+1,
              detailId: item.detailId ? Number(item.detailId) : null,
              titleId: Number(defaultInfo.value.titleId),
            }) 
            if(res){
              ElMessage({ type: 'success',message: '提交成功！'})
              if(res.detailId){
                item.detailId=res.detailId
              }
               item.isDisabled=true;
            }  
         }catch(error){
          console.log('表单验证或提交失败:', error);
        } 
    }else{
      ElMessage.error(`请先提交素材模板标题和排序！`);
    }
};


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "speech",
      deleteTip: "确认删除此模版项吗？",
      delUrl: "/main/speech/deleteSpeechTitle",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      numOfClicks: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row?.numOfClicks ?? 0), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      width: "60%",
      submitShow: false,
      pageName: "speech",
      validOtherInfo: () => true
    }, {
      other: _withCtx(({ show }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            onClick: handleCancleClick,
            disabled: btnDisabled.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("重置")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: btnDisabled.value,
            onClick: handleConfirmClick
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_collapse, {
            modelValue: activeCollapseItems.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeCollapseItems).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_collapse_item, {
                  key: `contents-${item.id || item.detailId || index}`,
                  name: `contents-${item.id || item.detailId || index}`
                }, {
                  title: _withCtx(({  }) => [
                    _createElementVNode("div", _hoisted_4, " 素材" + _toDisplayString(index+1), 1),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      icon: "el-icon-delete",
                      size: "mini",
                      onClick: _withModifiers(($event: any) => (handleItemRemove(index,formList.value,item)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (item.isDisabled)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-edit",
                          onClick: _withModifiers(($event: any) => (handleSubmit(index,formList.value,item)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          size: "mini",
                          icon: "el-icon-check",
                          onClick: _withModifiers(($event: any) => (handleSubmit(index,formList.value,item)), ["stop"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("提交")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(ElForm), {
                      "label-width": 100,
                      model: item,
                      disabled: item.isDisabled,
                      ref_for: true,
                      ref: (el) => setFormRef(el, index),
                      rules: dynamicRules
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "素材类型",
                          prop: "contentType",
                          class: "form-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              style: {"width":"100%"},
                              modelValue: item.contentType,
                              "onUpdate:modelValue": ($event: any) => ((item.contentType) = $event),
                              onChange: ($event: any) => (item.content=''),
                              filterable: "",
                              "default-first-option": ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (option) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: option.value,
                                    value: option.value,
                                    label: option.label
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(option.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_form_item, {
                          label: "素材排序",
                          class: "form-item",
                          prop: "sort"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "number",
                              style: {"width":"100px"},
                              modelValue: item.sort,
                              "onUpdate:modelValue": ($event: any) => ((item.sort) = $event),
                              placeholder: "数字"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_form_item, {
                          label: "素材",
                          prop: "content",
                          class: "form-item",
                          rules: getContentRules(item.contentType)
                        }, {
                          default: _withCtx(() => [
                            (item.contentType =='1')
                              ? (_openBlock(), _createBlock(RichTextEditor, {
                                  key: 0,
                                  modelValue: item.content,
                                  "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                                  disabled: item.isDisabled
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                              : (item.contentType =='4')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 1,
                                    type: "textarea",
                                    rows: 3,
                                    autosize: { minRows: 2, maxRows: 6 },
                                    modelValue: item.content,
                                    "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                                    placeholder: "请输入素材"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (item.contentType =='2')
                                  ? (_openBlock(), _createBlock(_component_el_upload, {
                                      key: 2,
                                      "auto-upload": true,
                                      action: action.value,
                                      data: extraData.value,
                                      "file-list": item.urlLists,
                                      "before-upload": (file) => beforeUpload(file,item) ,
                                      accept: ".jpeg,.jpg,.png",
                                      "before-remove": (uploadFile, uploadFiles) => handleImgRemove(uploadFile, uploadFiles, item),
                                      limit: 1,
                                      class: _normalizeClass({ hideUpload: item.content }),
                                      "list-type": "picture-card",
                                      "on-preview": (file) => handlePreview(file,item) 
                                    }, {
                                      tip: _withCtx(() => [
                                        _hoisted_6
                                      ]),
                                      default: _withCtx(() => [
                                        _hoisted_5
                                      ]),
                                      _: 2
                                    }, 1032, ["action", "data", "file-list", "before-upload", "before-remove", "class", "on-preview"]))
                                  : (item.contentType =='3')
                                    ? (_openBlock(), _createBlock(_component_el_upload, {
                                        key: 3,
                                        "auto-upload": true,
                                        action: action.value,
                                        data: extraData.value,
                                        "file-list": item.urlLists,
                                        "before-upload": (file) => beforeUpload(file,item) ,
                                        accept: ".mp4,.avi,.mov,.wmv,.flv,.mkv",
                                        "before-remove": (uploadFile, uploadFiles) => handleImgRemove(uploadFile, uploadFiles, item),
                                        limit: 1,
                                        "on-preview": (file) => handlePreview(file,item) 
                                      }, {
                                        tip: _withCtx(() => [
                                          _hoisted_7
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_button, { type: "primary" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("点击上传")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["action", "data", "file-list", "before-upload", "before-remove", "on-preview"]))
                                    : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["rules"])
                      ]),
                      _: 2
                    }, 1032, ["model", "disabled", "rules"])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin":"10px 0 10px 100px"},
            icon: "el-icon-plus",
            size: "mini",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addContent(formList.value)))
          })
        ])
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title"]),
    _createVNode(_component_el_dialog, {
      title: "预览",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
      width: "50%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (_unref(dialogType)=='2')
          ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              src: _unref(dialogUrl),
              fit: "fit",
              lazy: ""
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        (_unref(dialogType)=='3')
          ? (_openBlock(), _createElementBlock("video", _hoisted_8, [
              _createElementVNode("source", { src: _unref(dialogUrl) }, null, 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})